import {
	ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output,
	SimpleChanges
} from "@angular/core";

interface Year {
	date: Date;
	disabled: boolean;
	isOutside: boolean;
}

@Component({
	selector: "app-year-picker",
	templateUrl: "./year-picker.component.html",
	styleUrls: ["./../date-picker/date-picker.component.scss", "./year-picker.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class YearPickerComponent {
	@Input() public now: Date = new Date();
	@Input() public value?: Date;
	@Input() public disableSelectDate = false;
	@Output() public changePicker = new EventEmitter<Date>();
	@Output() public valueChange = new EventEmitter<Date>();
	public date: Date = new Date();
	public isDisabled = true;
	public years: Year[] = [];

	constructor(private readonly changeDetectorRef: ChangeDetectorRef) { }

	public ngOnChanges(simpleChanges: SimpleChanges): void {
		if (simpleChanges.value && this.value) {
			this.setView(this.value);
		} else {
			this.date = this.now || new Date();
			this.setView(this.date);
		}

		if (simpleChanges.now && !this.now)
			this.now = new Date();
	}

	public switchYear(date: Date, isForward: boolean): void {
		const today = new Date();
		const min = new Date(1900, 0, 1);
		const max = new Date(today.getFullYear() + 10, today.getMonth());
		date = new Date(date.valueOf());
		// date.setDate(1);
		if (min <= date && !isForward) {
			date.setFullYear(date.getFullYear() - 1);
		}
		else if (date < max && isForward) {
			date.setFullYear(date.getFullYear() + 1);
		}
		else {
			this.isDisabled = false;
		}
		this.date = date;
		this.setView(date);
		this.changeDetectorRef.detectChanges();
	}

	public isSelected(date: Date): boolean {
		if (!this.value)
			return false;
		return date.getFullYear() === this.value.getFullYear()
			&& date.getMonth() === this.value.getMonth();
	}

	public setYear(date: Date): void {
		this.value = new Date(date.valueOf());
		this.date = this.value;
		this.valueChange.emit(date);
	}

	public isToday(date: Date): boolean {
		return date.getFullYear() === this.now.getFullYear()
			&& date.getMonth() === this.now.getMonth();
	}

	public disabled(date: Date): boolean {
		const value = new Date(date.getFullYear(), date.getMonth() + 1);
		const today = new Date();
		const min = new Date(1900, 0, 1);
		const max = new Date(today.getFullYear() + 10, today.getMonth());
		return !(min <= value && value <= max);
	}

	public setView(date: Date): void {
		let year = new Date(date.getFullYear(), 0, 1);
		const years: Year[] = [];
		do {
			years.push({
				date: year,
				disabled: this.disabled(date),
				isOutside: year.getFullYear() !== date.getFullYear(),
			});
			year = new Date(year.valueOf());
			year.setMonth(year.getMonth() + 1);
		} while (years.length < 12);

		this.years = years;
		this.date = date;
		this.changeDetectorRef.detectChanges();
	}
}

